export function jsToRSQL(jsExpr?: string): string | undefined {
  return jsExpr
    ? jsExpr
        .replace(/\s*&&\s*/g, ';')
        .replace(/\s*\|\|\s*/g, ',')
        .replace(/([^\s!<>=]+)\s*==\s*([^\s&|()]+)/g, '$1==$2')
        .replace(/([^\s!<>=]+)\s*!=\s*([^\s&|()]+)/g, '$1!=$2')
        .replace(/([^\s<>=]+)\s*>=\s*([^\s&|()]+)/g, '$1=ge=$2')
        .replace(/([^\s<>=]+)\s*<=\s*([^\s&|()]+)/g, '$1=le=$2')
        .replace(/([^\s<>=]+)\s*>\s*([^\s&|()]+)/g, '$1=gt=$2')
        .replace(/([^\s<>=]+)\s*<\s*([^\s&|()]+)/g, '$1=lt=$2')
        .replace(/([^\s]+)\s+in\s+\(([^)]+)\)/gi, (_, field, values) => {
          const list = values
            .split(',')
            .map(v => v.trim())
            .join(',')

          return `${field}=in=(${list})`
        })
        .replace(/([^\s]+)\s+not\s+in\s+\(([^)]+)\)/gi, (_, field, values) => {
          const list = values
            .split(',')
            .map(v => v.trim())
            .join(',')

          return `${field}=out=(${list})`
        })
        .replace(/\s+/g, '')
    : undefined
}
